<template>
  <div>
    <div class="rounded bg-gray-50 pt-7 pb-9 md:px-7">
      <h3 class="ota-title mb-1 text-center text-2xl md:text-left md:mb-0" v-text="$t('HomePage.WeWearHashtag')" />
      <div class="md:flex md:justify-between">
        <h4 class="ota-small-light mb-7 text-center md:text-left md:mb-0" v-text="$t('HomePage.StayTuned')" />
        <div v-if="!hideSocials" class="flex justify-center cursor-pointer">
          <button :aria-label="$t('Accessibilty.AriaLabels.GoToName', { name: 'Instagram' })" @click="openNewTab($t('HomePage.IGLink'))">
            <OSvg svg="instagram" class="h-6 w-auto mr-3" />
          </button>
          <button :aria-label="$t('Accessibilty.AriaLabels.GoToName', { name: 'Facebook' })" @click="openNewTab($t('HomePage.FBLink'))">
            <OSvg svg="facebook" class="h-6 w-auto mr-3" />
          </button>
          <button :aria-label="$t('Accessibilty.AriaLabels.GoToName', { name: 'Youtube' })" @click="openNewTab($t('HomePage.YTLink'))">
            <OSvg svg="youtube" class="h-6 w-auto" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const OSvg = () => import('@/components/OSvg')

export default {
  name: 'Socials',
  components: {
    OSvg
  },
  props: {
    hideSocials: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openNewTab (url) {
      window.open(url, '_blank', 'noopener')
    }
  }
}
</script>

<style>

</style>
